<img *ngIf="pictureURL" [src]="pictureURL">
<span *ngIf="!pictureURL && letters">{{letters}}</span>
<span *ngIf="!pictureURL && !letters" class="icon icon-person-1"></span>